import axios from "axios";
const CUSTOMER_API_ENDPOINT = process.env.REACT_APP_public_url+"/public/customer";

const BACKEND_API_ENDPOINT = process.env.REACT_APP_backend_url+"/public/bespoke";

export const getCustomersConfigurationList = async (customerId) => {
  return await axios.get(CUSTOMER_API_ENDPOINT + `/${customerId}/configurations`);
}

export const createNewCustomerId = async (payload) => {
  return await axios.post(CUSTOMER_API_ENDPOINT + `/add`, payload);
}

export const requestAddNewHistory = async (customerId, bespokeCode, payload ) => {
  return await axios.post(CUSTOMER_API_ENDPOINT + `/${customerId}/design/${bespokeCode}`, payload);
}

export const updateHistory = async (customerId, bespokeCode, payload) => {
  return await axios.put(CUSTOMER_API_ENDPOINT + `/${customerId}/design/${bespokeCode}`, payload);
}

export const deleteHistory = async (customerId, bespokeCode) => {
  return await axios.delete(CUSTOMER_API_ENDPOINT + `/${customerId}/design/${bespokeCode}`);
}

export const loadMyDesign = async (bespokeCode)=>{
  return await axios.get(BACKEND_API_ENDPOINT+'/load?bespokeCode='+bespokeCode);
}
